import React from 'react';
import SummaryCard from './SummaryCard';

const priorityColors = {
    High: 'bg-pink-100 text-pink-600',
    Medium: 'bg-orange-100 text-orange-600',
    Low: 'bg-green-100 text-green-600',
};

const typeColors = {
    'Life Insurance': 'text-purple-600',
    'Cyber Insurance': 'text-purple-600',
    'Immediate Action': 'text-purple-600',
    'Short Term Action': 'text-purple-600',
    'Long Term Action': 'text-purple-600',
    // Add more types as needed based on your data
};

function ActionPlan({ items }) {
    const getTypeColor = (type) => {
        return typeColors[type] || 'text-purple-600'; // Default to purple if type not found
    };

    return (
        <SummaryCard title="Action Plan & Implementation Checklist">
            <div className="space-y-4">
                {items.map((item, idx) => (
                    <div
                        key={idx}
                        className="bg-white rounded-xl border-2 p-4 relative"
                        style={{ border: '1px solid rgba(0, 0, 0, 0.5)' }}
                    >
                        {/* Header with type and priority */}
                        <div className="flex justify-between items-start mb-3">
                            <span className={`content-text font-medium ${getTypeColor(item.type)}`}>
                                {item.type}
                            </span>
                            <span
                                className={`px-3 py-1 rounded-full content-text text-xs font-medium ${priorityColors[item.priority] || priorityColors.High}`}
                            >
                                {item.priority} Priority
                            </span>
                        </div>

                        {/* Due date */}
                        <div className="flex items-center gap-2 mb-3">
                            <span className="text-gray-400">🕐</span>
                            <span className="content-text text-gray-500 text-sm">
                                Due by {item.due}
                            </span>
                        </div>

                        {/* Title */}
                        <h4 className="content-text font-medium text-gray-900 mb-2">
                            {item.title}
                        </h4>

                        {/* Description */}
                        <p className="content-text text-gray-500 text-sm leading-relaxed">
                            {item.description}
                        </p>
                    </div>
                ))}
            </div>
        </SummaryCard>
    );
}

export default ActionPlan;